import Helper from './Helper';

class Offerings {
  constructor(config = {}) {
		const {
			offeringsContainer,
			filterButtonSelector,
			filterButtonDataAttribute,
			graphicsContainerSelector
		} = config;

		this.graphicsContainerSelector = graphicsContainerSelector;
		this.filterButtonDataAttribute = filterButtonDataAttribute;
		this.filterButtonSelector = filterButtonSelector;
		this.offeringsContainer = document.querySelector(offeringsContainer);
		this.filterButton = document.querySelectorAll(filterButtonSelector);
		this.graphicContainer = document.querySelectorAll(`${this.graphicsContainerSelector} > g`);
		this.graphicContainerArray = Array.prototype.slice.call(this.graphicContainer);
		this.filterButtonArray = Array.prototype.slice.call(this.filterButton);

		if(this.offeringsContainer){
			this.loadInitialView('all');
			this.bindEvents();
		}
  }

	loadInitialView(firstViewID){
		// console.log('initial');
		this.makeActive(document.querySelector(`${this.filterButtonSelector}[data-${this.filterButtonDataAttribute}='${firstViewID}']`));
	}

  bindEvents() {
		this.filterButtonArray.forEach(button => {
      button.addEventListener('click', e => {
				const data = Helper.camelCase(this.filterButtonDataAttribute);
				const dataValue = button.dataset[data];
				this.makeActive(button);
				this.showBox(dataValue);
      })
		});
	}

	showBox(groupClass){
		// console.log(groupClass);
		this.graphicContainerArray.forEach(g => {
			// console.log(g);
			if(Helper.hasClass(g, groupClass)){
				Helper.addClass(g, 'active');
				Helper.addClass(g, 'animate--in');
				Helper.removeClass(g, 'animate--out');
			} else {
				Helper.removeClass(g, 'active');
				Helper.addClass(g, 'animate--out');
				Helper.removeClass(g, 'animate--in');
			}
		});
	}

	makeActive(button){
		this.filterButtonArray.forEach(b => {
			Helper.removeClass(b, 'active');
		});
		Helper.addClass(button, 'active');
	}
}

export default Offerings;
